module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/menu_kurashi-0ef57d078f0f5629c4dea441e875105b.png";